import React from 'react';
import "./DescriptionBox.css";

export default function DescriptionBox() {
  return (
    <div className='descriptionbox'>

        <div className="descriptionbox-navigator">
            <div className="descrptionbox-nav-box">Description</div>
            <div className="descrptionbox-nav-box fade">Reviews (122)</div>
        </div>
        
        <div className="descriptionbox-description">
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, suscipit.
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Error perferendis nostrum at nesciunt architecto omnis alias sapiente quibusdam totam eos et magni suscipit, dolorem fugit vitae amet blanditiis! Provident quaerat error quia quidem autem sapiente quae corrupti at! Debitis repudiandae accusantium eveniet dolorem dignissimos quasi non tempora dolore molestiae mollitia. </p>
            <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Asperiores error reiciendis vel eius, tempore maiores neque illum pariatur ipsam temporibus voluptas ducimus explicabo quasi sunt cupiditate et deleniti! Deserunt, officia. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Modi, exercitationem.
            </p>

        </div>
    </div>
  )
}
